import { useEffect, useState } from "react"
import PropTypes from "prop-types";

const expandFirstId = (ids, expanded) => {
    const x = {}
    ids?.length > 0 && ids.forEach((id, index) => index === 0 ? x[id] = true :
        expanded[id] ? x[id] = true : x[id] = false)
    return x
};

const useCollapsible = ({ Ids, expandFirst, expandAllByDefault }) => {
    const [expanded, setExpanded] = useState({});

    useEffect(() => {
        if (expandFirst) {
            setExpanded({ ...expandFirstId(Ids, expanded) })
        }
        if (expandAllByDefault) {
            const x = {}
            Ids.forEach((id) => x[id] = true)
            setExpanded({ ...x })
        }
    }, [Ids])

    const areAllExpanded = () => {
        const keys = Object.keys(expanded);
        let is = true
        keys.forEach((key) => {
            if (expanded[key] === false) { is = false }
        })
        return is
    };

    const areAllCollapsed = () => {
        const keys = Object.keys(expanded);
        let is = true
        keys.forEach((key) => {
            if (expanded[key] === true) { is = false }
        })
        return is
    };

    const expandAll = () => {
        const x = {}
        Ids?.length > 0 && Ids.forEach((id) => x[id] = true)
        setExpanded(x);
    };

    const isExpanded = (id) => {
        return !!expanded[id]
    };

    const collapseAll = () => {
        const x = {}
        Ids?.length > 0 && Ids.forEach((id) => x[id] = false)
        setExpanded(x);
    };

    const toggleById = (selectedId, closeAllToggleById = false) => {
        if (!closeAllToggleById) {
            setExpanded({ ...expanded, [selectedId]: !expanded[selectedId] })
        } else {
            const x = {}
            Ids?.forEach((id) => {
                if (selectedId === id) {
                    x[selectedId] = !expanded[selectedId]
                } else {
                    delete x[id]
                }
            })
            setExpanded(x)
        }
    };

    const expandById = (id) => {
        setExpanded({ ...expanded, [id]: true })
    };

    const collapseById = (id) => {
        const newExpanded = { ...expanded };
        delete newExpanded[id];
        setExpanded(newExpanded);
    };

    const expandMultipleIds = (ids) => {
        const x = { ...expanded };
        ids.forEach((id) => (x[id] = true));
        setExpanded(x);
    }

    const collapseMultipleIds = (ids) => {
      const x = { ...expanded };
      ids.forEach((id) => (delete x[id]));
      setExpanded(x);
    };

    const areIdsExpanded = (ids) => {
        for(let i = 0 ; i < ids.length ; i++){
            if (!expanded[ids[i]]) { return false; }
        }
        return true;
    };

    const areIdsCollapsed = (ids) => {
        for(let i = 0 ; i < ids.length ; i++){
            if (expanded[ids[i]]) { return false; }
        }
        return true;
    };

    return {
        expanded,
        toggleById,
        expandAll,
        collapseAll,
        isExpanded,
        collapseById,
        expandById,
        areAllExpanded,
        areAllCollapsed,
        expandMultipleIds,
        collapseMultipleIds,
        areIdsExpanded,
        areIdsCollapsed,
    }
}

useCollapsible.defaultProps = {
    Ids: [],
    expandFirst: false,
    expandAllByDefault: false,
}

useCollapsible.propTypes = {
    Ids: PropTypes.array,
    expandFirst: PropTypes.bool,
    expandAllByDefault: PropTypes.bool,
}

export default useCollapsible;